import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  container: {
      height: "24px",
      width: "24px",
      marginRight: "8px",
      padding: "6px 4px 4px 4px",
      background: "rgba(48, 73, 103, 0.8)",
      'text-align': 'center',
      "border-radius": "50%",
      display: "inline-block",
      "justify-content": "center",
      "align-items": "center",
      "line-height": "14px",
      marginBottom: 4
  },
  containerLg: {
      height: "24px",
      width: "auto",
      marginRight: "8px",
      padding: "5px 4px",
      background: "rgba(48, 73, 103, 0.8)",
      'text-align': 'center',
      "border-radius": "12px",
      display: "inline-block",
      "justify-content": "center",
      "align-items": "center",
      "line-height": "14px",
      marginBottom: 4
  },
  symb: {
      fontWeight: "bold",
      fontSize: "12px",
      color: "#FFFFFF"
  },
  symbSmall: {
    fontWeight: "bold",
    fontSize: "10px",
    textTransform: "lowercase",
    color: "#FFFFFF"
  }
});

const RoleSymbol = ({ title, symbol, lg = false }) => {
  const { container, containerLg, symb, symbSmall } = useStyles();

  return (
    lg ?
    <div className={containerLg}>
          <div className={symb}>{title}</div>
      </div>
    :  <div className={container} title={title}>{
        symbol !== null && symbol.length > 2 ?
          <div className={symbSmall}>{symbol}</div> :
          <div className={symb}>{symbol}</div>
      }
      </div>
  );
};

export default RoleSymbol;
